// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plantilla {
    border-radius: 5px;
    padding: 5px;
}
.plantilla:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
.plantilla-selected {
    background-color: rgba(0, 0, 0, 0.1);
}
.plantilla label {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/plantillas/plantillas.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,eAAe;AACnB","sourcesContent":[".plantilla {\n    border-radius: 5px;\n    padding: 5px;\n}\n.plantilla:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n.plantilla-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n.plantilla label {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
